import { z } from 'zod'

export const IOTypeSchema = z.enum(['Input', 'Output', 'Both'])
export type IOType = z.infer<typeof IOTypeSchema>
